import { StatusBadge } from "../atoms/StatusBadge";
import { DataCell } from "../atoms/DataCell";
import { STYLES } from "../../config/styles";

interface StatusCellProps {
  status: string;
  statusBucket?: string;
  showBadge?: boolean;
}

export function StatusCell({ status, statusBucket, showBadge = true }: StatusCellProps) {
  return (
    <td className={STYLES.table.cellPadding}>
      {showBadge ? (
        <StatusBadge status={status} statusBucket={statusBucket} />
      ) : (
        <DataCell>{status}</DataCell>
      )}
    </td>
  );
}
